package com.arena_web.ui.localization

object AppStringsUA : AppStrings {

    // language selector
    override val headerProfileLanguage = "Мова"
    override val headerProfileLanguageRecommended = "Рекомендовано"

    // common
    override val commonSeeAll = "Дивитися всі"
    override val commonNo = "Ні"
    override val commonYes = "Так"
    override val commonConfirm = "Підтвердити"
    override val commonSend = "Надіслати"
    override val commonError = "Помилка"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Увімкнути сповіщення"
    override val chatMenuMute = "Вимкнути сповіщення"
    override val chatMenuInviteMembers = "Запросити учасників"
    override val chatMenuLeaveGroup = "Покинути групу"
    override val chatMenuDeleteChat = "Видалити чат"
    override fun chatRemoveMemberTitle(name: String) = "Видалити $name?"
    override fun chatRemoveMemberWarning(name: String) = "Видалити $name з групи? Цю дію не можна скасувати."
    override val chatRemoveMemberAction = "Видалити"
    override val chatDefaultName = "Чат"
    override fun chatTypingOne(name: String) = "$name пише..."
    override fun chatTypingMany(count: Int) = "$count людей пишуть..."
    override fun chatMembersCount(count: Int) = "$count учасників"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count учасників, $online онлайн"
    override val chatOnline = "Онлайн"
    override val chatOffline = "Офлайн"
    override val chatEditCommunityTitle = "Редагувати спільноту"
    override val chatCommunityNameLabel = "Назва спільноти"
    override val chatCommunityNamePlaceholder = "Введи назву спільноти..."
    override val chatSaving = "Збереження..."
    override val chatMessageInputPlaceholder = "Напиши повідомлення..."
    override val chatInviteMembersTitle = "Запросити учасників"
    override val chatSearchFriendsPlaceholder = "Пошук друзів..."
    override val chatNoFriendsToInvite = "Немає друзів для запрошення"
    override val chatNoResults = "Нічого не знайдено"
    override val chatInviting = "Запрошуємо..."
    override val chatInvite = "Запросити"
    override fun chatInviteCount(count: Int) = "Запросити ($count)"
    override val chatPanelTitle = "Чат Arena"
    override val chatSearchPlaceholder = "Пошук чатів"
    override val chatFilterAll = "Усі"
    override val chatFilterDirect = "Особисті"
    override val chatFilterCommunity = "Спільноти"
    override val chatNoChatsFound = "Чатів не знайдено"
    override val chatNoConversationsYet = "Розмов поки немає"
    override val chatNewChatTitle = "Новий чат"
    override val chatTabDirectMessage = "Особисте повідомлення"
    override val chatTabCommunity = "Спільнота"
    override val chatSearchPeoplePlaceholder = "Шукай людей, на яких ти підписаний..."
    override val chatNotFollowingAnyone = "Ти поки ні на кого не підписаний"
    override val chatCreating = "Створення..."
    override val chatCreateCommunity = "Створити спільноту"
    override val chatSelectConversation = "Вибери розмову"
    override fun chatReplyTo(name: String) = "Відповісти $name"
    override val chatUnknownSender = "Невідомо"
    override val chatUploading = "Завантаження..."
    override val chatEditingMessage = "Редагування повідомлення"
    override val chatSearchInChatPlaceholder = "Пошук у чаті..."
    override fun chatSearchResultsFound(count: Int) = "Знайдено: $count"
    override val chatGroupInfoTitle = "Про групу"
    override val chatUserInfoTitle = "Про користувача"
    override val chatDeleteChatAction = "Видалити чат"
    override val chatDeleteGroupAction = "Видалити групу"
    override val chatLeaveGroupAction = "Покинути групу"
    override val chatLastSeenRecently = "нещодавно в мережі"
    override val chatNotificationsLabel = "Сповіщення"
    override val chatTabMembers = "Учасники"
    override val chatTabMedia = "Медіа"
    override val chatTabFiles = "Файли"
    override val chatTabLinks = "Посилання"
    override val chatLoading = "Завантаження..."
    override val chatNoMediaYet = "Медіа поки немає"
    override val chatNoFilesYet = "Файлів поки немає"
    override val chatUnknownFile = "Невідомий файл"
    override val chatNoLinksYet = "Посилань поки немає"
    override val chatNoMembers = "Немає учасників"
    override val chatRoleOwner = "Власник"
    override val chatRoleAdmin = "Адмін"
    override val chatEdited = "змінено"
    override val chatFileFallback = "Файл"
    override val chatMenuReply = "Відповісти"
    override val chatMenuPin = "Закріпити"
    override val chatEmptyTitle = "Чатів поки немає"
    override val chatEmptySubtitle = "Почни розмову, щоб бачити тут свої повідомлення."
    override val chatUnnamed = "Без назви"
    override val chatNoMessagesYet = "Повідомлень поки немає"
    override val chatRoomEmptyTitle = "Повідомлень поки немає"
    override val chatRoomEmptySubtitle = "Привітайся, щоб почати розмову."
    override fun chatMembersHeader(count: Int) = "Учасники ($count)"
    override val chatNoMediaSharedYet = "Медіа поки не надсилали"
    override val chatNoFilesSharedYet = "Файли поки не надсилали"
    override val chatNoLinksSharedYet = "Посилання поки не надсилали"

    // widget
    override val widgetDismiss = "Закрити"
    override val widgetSomethingWentWrong = "Щось пішло не так"
    override val widgetTryAgain = "Спробувати ще"
    override val widgetCookieTitle = "Ми використовуємо cookies"
    override val widgetCookieMessage = "Цей сайт використовує cookies, щоб забезпечити найкращий досвід."
    override val widgetCookieDecline = "Відхилити"
    override val widgetCookieAccept = "Прийняти"
    override val widgetAddInterval = "Додати інтервал"
    override val widgetSendMessage = "Надіслати повідомлення"
    override val widgetPrevious = "Назад"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Активний"
    override val widgetStatusDebtor = "Боржник"
    override val widgetStatusInactive = "Неактивний"
    override val widgetUnpaid = "не оплачено"
    override val widgetStatusInProgress = "Триває"
    override val widgetStatusUpcoming = "Незабаром"
    override val widgetStatusPending = "Очікує"
    override val widgetStatusCompleted = "Завершено"
    override fun widgetFieldLabel(number: String) = "Поле $number"
    override val widgetYearly = "За рік"
    override val widgetAllFields = "Усі поля"
    override val widgetPreviousMonth = "Попередній місяць"
    override val widgetNextMonth = "Наступний місяць"
    override val widgetSortAscending = "Сортувати за зростанням"
    override val widgetSortDescending = "Сортувати за спаданням"
    override val widgetChecked = "Вибрано"

    // form
    override val formSelectPlaceholder = "Вибрати..."

    // common
    override val commonCancel = "Скасувати"
    override val commonSave = "Зберегти"
    override val commonDelete = "Видалити"
    override val commonEdit = "Редагувати"
    override val commonNext = "Далі"
    override val commonRetry = "Повторити"
    override val commonSearch = "Пошук"

    // event
    override val eventMatchEndedTitle = "МАТЧ ЗАВЕРШЕНО"
    override val eventMatchEndedSubtitle = "Оціни гравців, щоб оновити їхні особисті рейтинги."
    override val eventTabMatchInfo = "Інфо матчу"
    override val eventTabLineups = "Склади"
    override val eventTabMedia = "Медіа"
    override val eventCreateTeam = "Створити команду"
    override val eventCancelEventQuestion = "Скасувати подію?"
    override val eventDeleteEventQuestion = "Видалити подію?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" буде позначено як скасовану."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" буде видалено назавжди."
    override val eventCancelNoticeParticipants = "Інші учасники отримають сповіщення. Чат та історія залишаться доступними."
    override val eventDeleteNoticeMedia = "Зображення події та чат теж буде видалено."
    override val eventKeepEvent = "Залишити подію"
    override val eventCancelling = "Скасування..."
    override val eventDeleting = "Видалення..."
    override val eventCancelEvent = "Скасувати подію"
    override val eventMatchPerformanceTitle = "Показники матчу"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Статистика"
    override val eventProPlusStatDescription = "Детальна точність ударів, відсоток передач і володіння м'ячем."
    override val eventLoadingMedia = "Завантаження медіа..."
    override val eventDeleteMediaQuestion = "Видалити медіа?"
    override val eventDeleteMediaMessage = "Цей файл буде видалено з події для всіх."
    override val eventNoMediaYet = "Медіа поки немає"
    override val eventNoMediaDescription = "Фото та відео з цього матчу з'являться тут."
    override val eventInviteTeamTitle = "Запросити команду"
    override val eventSearchTeamsLabel = "Пошук команд"
    override val eventSearchTeamsPlaceholder = "Введи назву команди..."
    override val eventSearching = "Пошук..."
    override val eventNoTeamsFound = "Команд не знайдено"
    override fun eventTeamRating(rating: String) = "Рейтинг $rating"
    override fun eventTeamMembersCount(count: Int) = "$count учасників"
    override val eventInviteStatusAccepted = "Прийнято"
    override val eventInviteStatusDeclined = "Відхилено"
    override val eventInviteStatusInvited = "Запрошено"
    override val eventInvite = "Запросити"
    override val eventStartEventQuestion = "Почати подію?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" перейде в лайв."
    override val eventStartNotice = "Реєстрація закриється, і матч розпочнеться."
    override fun eventPendingRequestOne(count: Int) = "$count запит в очікуванні"
    override fun eventPendingRequestsMany(count: Int) = "Запитів в очікуванні: $count"
    override val eventPendingRequestsSubtitle = "Ці гравці подали запит на участь, але їх ще не підтвердили."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count гравець без команди"
    override fun eventPlayersWithoutTeamMany(count: Int) = "Гравців без команди: $count"
    override val eventTeamlessSubtitle = "Вони підтверджені, але не призначені до жодної команди."
    override val eventStarting = "Починаємо..."
    override val eventStartAnyway = "Почати все одно"
    override val eventMonthJanuary = "Січень"
    override val eventMonthFebruary = "Лютий"
    override val eventMonthMarch = "Березень"
    override val eventMonthApril = "Квітень"
    override val eventMonthMay = "Травень"
    override val eventMonthJune = "Червень"
    override val eventMonthJuly = "Липень"
    override val eventMonthAugust = "Серпень"
    override val eventMonthSeptember = "Вересень"
    override val eventMonthOctober = "Жовтень"
    override val eventMonthNovember = "Листопад"
    override val eventMonthDecember = "Грудень"
    override val eventVs = "vs"
    override val eventTeamsLabel = "команд"
    override val eventPlayersLabel = "гравців"
    override val eventProBadge = "PRO"
    override val eventCompletedBadge = "Завершено"
    override val eventLeadersEmptyWinGame = "Виграй гру, щоб піднятися в таблиці лідерів."
    override val eventLeadersEmptyFirstScore = "Забий першим і очоль таблицю лідерів."
    override val eventLeadersEmptyTakeSet = "Візьми сет, щоб посісти перше місце."
    override val eventLeadersEmptyFirstAssist = "Стань першим, хто віддасть переможну передачу."
    override fun eventTopStat(name: String) = "Топ $name"
    override val eventPlayerFallback = "Гравець"
    override val eventCreateTeamSubtitle = "Сформуй свій склад на матч"
    override val eventTeamNameLabel = "Назва команди"
    override val eventTeamNameRequired = "Назва команди обов'язкова"
    override val eventTeamColorLabel = "Колір команди"
    override val eventTeamColorSubtitle = "Вибери колір своєї команди"
    override val eventTeamNamePlaceholder = "Введи назву команди..."
    override val eventChatTitle = "Чат"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Гравці"
    override val eventChatWaitingApproval = "Очікування підтвердження"
    override val eventChatConfirmingSpot = "Підтвердження твого місця"
    override val eventChatLocked = "Чат заблоковано"
    override val eventChatWaitingApprovalSubtitle = "Щойно адмін підтвердить твій запит, ти зможеш спілкуватися з командою."
    override val eventChatConfirmingSpotSubtitle = "Твій запит на участь обробляється. Чат відкриється, щойно тебе приймуть."
    override val eventChatPrivateSubtitle = "Це приватна подія. Надішли запит на участь і дочекайся підтвердження адміна."
    override val eventChatLockedSubtitle = "Приєднайся до матчу, щоб бачити розмову та спілкуватися з іншими гравцями."
    override val eventJoinEvent = "Приєднатися до події"
    override val eventChatNoMessages = "Повідомлень поки немає"
    override val eventChatNoMessagesSubtitle = "Почни розмову зі своєю командою."
    override val eventTeamSectionTitle = "Команда"
    override val eventDeleteTeam = "Видалити команду"
    override val eventViewProfile = "Переглянути профіль"
    override val eventRemoveAdmin = "Зняти адміна"
    override val eventMakeAdmin = "Зробити адміном"
    override val eventRemoveFromTeam = "Видалити з команди"
    override val eventRemoveFromEvent = "Видалити з події"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count команд"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max гравців"
    override fun eventPlayersCount(count: Int) = "$count гравців"
    override val eventStatusLive = "Live"
    override val eventLeave = "Покинути"
    override val eventStart = "Почати"
    override val eventJoin = "Приєднатися"
    override val eventStatusPending = "Очікує"
    override val eventStatusCanceled = "Скасовано"
    override val eventPendingApprovalBadge = "Очікує підтвердження"
    override val eventRatePerformanceTitle = "Оціни гру"
    override val eventRateVoteCounts = "Твій голос важливий!"
    override val eventCommunityRating = "Рейтинг спільноти"
    override val eventSubmitRating = "Надіслати оцінку"
    override val eventSubmitting = "Надсилання..."
    override val eventAddMediaTitle = "Додати медіа"
    override val eventUploadMedia = "Завантажити медіа"
    override val eventDropMediaHere = "Перетягни сюди фото та відео"
    override val eventMaxFileSize = "макс. 30 МБ"
    override val eventSelectedLabel = "Вибрано"
    override val eventClearAll = "Очистити все"
    override val eventAddToTeam = "Додати до команди"
    override val eventMakeSubstitution = "Зробити заміну"
    override val eventViewProfileSheet = "Переглянути профіль"
    override fun eventSwapWith(name: String) = "Замінити $name на"
    override val eventEndMatch = "Завершити матч"
    override val eventReset = "Скинути"
    override val eventLeadersEmptyWinGameShort = "Виграй гру, щоб піднятися в таблиці лідерів"
    override val eventLeadersEmptyScoreFirst = "Забий першим і очоль таблицю лідерів"
    override val eventLeadersEmptyTakeSetShort = "Візьми сет, щоб посісти перше місце"
    override val eventLeadersEmptyWinningAssist = "Зроби переможний асист"
    override val eventRatePlayersSubtitle = "Оціни гравців, щоб оновити топ рейтингу"
    override val eventGenericError = "Щось пішло не так"
    override val eventDeleteTeamQuestion = "Видалити команду?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" буде видалено з цієї події. Гравці цієї команди залишаться без команди."
    override val eventPlayersTitle = "Гравці"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "(Підтверджено $confirmed/$total)"
    override val eventAwaitingPlayers = "Чекаємо на гравців"
    override val eventAwaitingPlayersSubtitle = "Приєднайся до події зараз, щоб почати формувати команди."
    override val eventAssignToTeam = "Призначити в команду"
    override val eventFormatLabel = "Формат:"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Таймлайн"
    override val eventFormatAuto = "Авто"
    override val eventCoach = "Тренер"
    override val eventSaving = "Збереження..."
    override val eventCreating = "Створення..."
    override val eventSaveChanges = "Зберегти зміни"
    override val eventCreateEvent = "Створити подію"
    override val eventEditEventTitle = "Редагувати подію"
    override val eventErrorTitleRequired = "Вкажи назву"
    override val eventErrorSportRequired = "Вибери вид спорту"
    override val eventErrorSportNameRequired = "Вкажи назву виду спорту"
    override val eventErrorFormatRequiredPro = "Для Pro-подій потрібен формат"
    override val eventErrorStartTimeRequired = "Вкажи час початку"
    override val eventErrorEndTimeRequired = "Вкажи час завершення"
    override val eventErrorEndAfterStart = "Час завершення має бути пізніше за час початку"
    override val eventErrorStartInPast = "Час початку не може бути в минулому"
    override val eventErrorSelectAddress = "Вибери адресу"
    override val eventErrorAddressCity = "Вибери коректну адресу з містом"
    override val eventErrorCoverRequired = "Потрібне фото обкладинки"
    override val eventErrorSignInEdit = "Увійди, щоб редагувати події"
    override val eventErrorSignInCreate = "Увійди, щоб створювати події"
    override val eventErrorUploadImage = "Не вдалося завантажити зображення"
    override val eventErrorSaveChanges = "Не вдалося зберегти зміни"
    override val eventErrorCreateEvent = "Не вдалося створити подію"
    override val eventAddressLabel = "Адреса"
    override val eventAddressPlaceholder = "Пошук адреси..."
    override val eventTitleLabel = "Назва"
    override val eventTitlePlaceholder = "напр. Недільний футбольний матч"
    override val eventSportNameLabel = "Назва виду спорту"
    override val eventSportNamePlaceholder = "Введи назву виду спорту"
    override val eventMaxPlayersLabel = "Макс. гравців"
    override val eventMaxPlayersPlaceholder = "напр. 20"
    override val eventDateLabel = "Дата"
    override val eventTimeFromLabel = "З"
    override val eventTimeToLabel = "До"
    override val eventChooseOnMap = "Вибрати на карті"
    override val eventConfirmLocation = "Підтвердити локацію"
    override val eventAddPhoto = "Додати фото"
    override val eventSportLabel = "Спорт"
    override val eventLoading = "Завантаження..."
    override val eventSelectSportPlaceholder = "Вибери вид спорту"
    override val eventCommunityLabel = "Спільнота"
    override val eventCommunityNone = "Немає (публічна)"
    override val eventUnnamedGroup = "Група без назви"
    override val eventFormatFieldLabel = "Формат"
    override val eventSelectPlaceholder = "Вибрати"
    override val eventCostLabel = "Вартість"
    override val eventPrivateLabel = "Приватна"
    override val eventPrivateInfoDescription = "Керуй своїм складом: вручну підтверджуй запити на участь або видаляй учасників."

    // wallet
    override val walletTopUpTitle = "Поповнити гаманець"
    override val walletSelectAmount = "Вибери суму"
    override val walletOr = "або"
    override val walletCustomAmount = "Своя сума"
    override val walletEnterAmountPlaceholder = "Введи суму"
    override val walletProcessing = "Обробка…"
    override val walletTopUpAction = "Поповнити"

    // nav
    override val navDashboard = "Дашборд"
    override val navClients = "Клієнти"
    override val navChat = "Чат"
    override val navSchedule = "Розклад"
    override val navClubSettings = "Налаштування клубу"
    override val navArena = "Arena"
    override val navFeed = "Стрічка"
    override val navPeople = "Люди"
    override val navProfile = "Профіль"
    override val navStatistic = "Статистика"
    override val navTeam = "Команда"
    override val navMedia = "Медіа"
    override val navWeek = "Тиждень"
    override val navMonth = "Місяць"
    override val navYear = "Рік"

    // modal
    override val modalDecline = "Відхилити"
    override val modalCompleteSession = "Завершити сесію"
    override val modalTimeAlt = "Час"
    override val modalPriceAlt = "Ціна"
    override val modalBookings = "Бронювання"
    override val modalTotalSpent = "Всього витрачено"
    override val modalSendMessage = "Надіслати повідомлення"
    override val modalAddNote = "Додати нотатку"
    override val modalAdminNotes = "Нотатки адміна"
    override val modalAdminNotesPrivacy = "Приватно — бачать лише адміни"
    override val modalWriteNotePlaceholder = "Напиши нотатку..."
    override val modalAdd = "Додати"
    override val modalBookingHistory = "Історія бронювань"
    override val modalNoBookingsYet = "Бронювань поки немає"
    override val modalFieldFallback = "Поле"
    override val modalStatusConfirmed = "Підтверджено"
    override val modalStatusPending = "Очікує"
    override val modalStatusCompleted = "Завершено"
    override val modalStatusCancelled = "Скасовано"
    override val modalPaid = "Оплачено"
    override val modalUnpaid = "Не оплачено"

    // feed
    override val feedClubBadge = "Клуб"
    override fun feedAddAllPhotos(count: Int) = "Додати всі фото ($count)"
    override val feedUploadFailed = "Не вдалося завантажити"
    override val feedCreatePostFailed = "Не вдалося створити пост"
    override val feedCreatePostTitle = "Створити пост"
    override val feedChooseLayoutSubtitle = "Вибери макет для свого поста"
    override val feedFileTooLarge = "Файл завеликий (макс. 50 МБ)"
    override val feedChooseLayout = "Вибери макет"
    override val feedCreating = "Створення..."
    override val feedAddPhoto = "Додати фото"
    override val feedCityLabel = "Місто"
    override val feedEnterCityPlaceholder = "Введи назву міста..."
    override val feedPostContentLabel = "Текст поста"
    override val feedPostContentPlaceholder = "Напиши щось про цей пост..."
    override val feedOptional = "(Необов'язково)"
    override val feedPickPhotoFirst = "Спочатку вибери фото"
    override val feedCreateStoryFailed = "Не вдалося створити сторіз"
    override val feedCreateStoriesTitle = "Створити сторіз"
    override val feedCreateStoriesSubtitle = "Створюй і ділись своїми моментами"
    override val feedFileTooLargeStory = "Файл завеликий (макс. 30 МБ)"
    override val feedDropContentHere = "Перетягни сюди свій контент"
    override val feedMaxStorySize = " макс. 30 МБ"
    override val feedFollowingSection = "Підписки"
    override val feedFollowersSection = "Підписники"
    override val feedSearching = "Пошук…"
    override val feedNoResults = "Нічого не знайдено"
    override val feedLoadingMore = "Завантажуємо ще…"
    override val feedThisUser = "цього користувача"
    override fun feedUnfollowTitle(name: String) = "Відписатися від $name?"
    override val feedUnfollowSubtitle = "Ти можеш підписатися знову будь-коли."
    override val feedUnfollow = "Відписатися"
    override fun feedRemoveTitle(name: String) = "Видалити $name?"
    override val feedRemoveSubtitle = "Користувач не отримає сповіщення, але більше не бачитиме твої пости."
    override val feedRemove = "Видалити"
    override val feedFollow = "Підписатися"
    override val feedDeleted = "Видалено"
    override val feedNotFollowingTitle = "Ти поки ні на кого не підписаний"
    override val feedNotFollowingBody = "Підписуйся на гравців, щоб бачити їхні свіжі пости, хайлайти та сторіз у своїй стрічці."
    override val feedNoFollowersTitle = "Підписників поки немає"
    override val feedNoFollowersBody = "Ділись постами про матчі та сторіз, щоб тебе помітила спільнота."
    override val feedDiscoverPlayers = "Знайти гравців"

    // dropdown
    override val dropdownAllCities = "Усі міста"
    override val dropdownSelectedAlt = "Вибрано"

    // page
    override val pageScheduleTitle = "Розклад"
    override val pageScheduleComingSoon = "Розклад скоро з'явиться"
    override val pageEventsSeoTitle = "Спортивні події"
    override val pageEventsSeoDescription = "Переглядай і приєднуйся до спортивних подій поруч — футбол, теніс, баскетбол, падел та інше. Створи власну гру та запрошуй гравців на Arena."
    override val pageEventsTitle = "Події"
    override val pageCreateEvent = "Створити подію"
    override val pageNoEventsYet = "Подій поки немає"
    override val pageNotFoundTitle = "Ой, сторінку не знайдено"
    override val pageNotFoundBody = "Перевір адресу сторінки на помилки або повернися на головну арену."
    override val pageBackToArena = "Назад до Arena"
    override val pageChatTitle = "Чат"
    override val pageLoading = "Завантаження..."
    override val pageSomethingWentWrong = "Щось пішло не так"
    override fun pageUnfollowTitle(name: String) = "Відписатися від $name"
    override val pageRemoveFollowerTitle = "Видалити підписника?"
    override fun pageRemoveFollowerSubtitle(name: String) = "Ми не сповістимо $name про цю зміну."
    override val pageFeedTitle = "Стрічка"
    override val pageFeedSeoDescription = "Дивись, чим живе спортивна спільнота Arena — результати матчів, хайлайти та моменти від гравців поруч із тобою."
    override val pageNoPostsYet = "Постів поки немає"
    override val pageLoadingMore = "Завантажуємо ще..."
    override val pagePeopleSeoTitle = "Знайди гравців"
    override val pagePeopleSeoDescription = "Відкривай для себе спортсменів поруч, знаходь гравців свого рівня та об'єднуйтесь для наступної гри на Arena."
    override val pagePeopleTitle = "Люди"
    override val pageSquadUpTitle = "Збери команду"
    override val pageSquadUpSubtitle = "Знаходь партнерів, знайомся з гравцями та починай гру."
    override val pagePeopleLoadFailed = "Не вдалося завантажити людей"
    override val pagePeopleCaughtUpTitle = "Поки що все переглянуто"
    override val pagePeopleCaughtUpSubtitle = "Повертайся пізніше — буде більше гравців."
    override val pageRefresh = "Оновити"
    override val pageClientsTitle = "Клієнти"
    override fun pageClientsTotal(total: Int) = "Всього клієнтів: $total"
    override val pageActiveClients = "Активні клієнти"
    override val pageTotalBookings = "Всього бронювань"
    override val pageTotalRevenue = "Загальний дохід"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Активний"
    override val pageStatusDebtor = "Боржник"
    override val pageStatusAll = "Всі статуси"
    override val pageStatusInactive = "Неактивний"
    override val pageAddNewClient = "Додати клієнта"
    override val pageColName = "Ім'я"
    override val pageColRevenue = "Дохід"
    override val pageColStatus = "Статус"
    override val pageColLastVisit = "Останній візит"
    override val pageColActions = "Дії"
    override val pageUnpaidSuffix = "не оплачено"
    override val pagePrevious = "Назад"
    override val pagePageLabel = "Сторінка"
    override val pageOfLabel = "з"
    override val pageBackToEvents = "Назад до подій"
    override val pageResetTimerTitle = "Скинути таймер?"
    override val pageResetTimerMessage = "Таймер матчу повернеться до 00:00. Зібрана статистика збережеться."
    override val pageResetTimerConfirm = "Скинути"
    override val pageResetting = "Скидання..."
    override val pageEndMatchTitle = "Завершити матч?"
    override val pageEndMatchMessage = "Подію буде позначено як завершену, а рахунок зафіксовано."
    override val pageEndMatchConfirm = "Завершити матч"
    override val pageEnding = "Завершення..."
    override val pageAddMedia = "Додати медіа"
    override val pageBook = "Забронювати"
    override val pageCourtRules = "Правила корту"
    override val pageNoCourtRules = "Правила корту не вказані."
    override val pageLeaveReview = "Залишити відгук"
    override val pageNoReviewsYet = "Відгуків поки немає."
    override val pageSportFootball = "Футбол"
    override val pageSportBasketball = "Баскетбол"
    override val pageSportTennis = "Теніс"
    override val pageSportPadel = "Падел"
    override val pageClubFallback = "Клуб"
    override fun pageReviewExperienceTitle(sportName: String) = "Як тобі $sportName?"
    override val pageWriteReviewPlaceholder = "Напиши свій відгук..."
    override val pagePosting = "Публікація..."
    override val pagePostReview = "Опублікувати відгук"
    override val pageLoadMore = "Завантажити ще"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "Твоя спортивна кар'єра як на долоні — статистика, рейтинги й досягнення у футболі, тенісі, баскетболі та інших видах спорту на Arena."
    override val pageEventsTab = "Події"
    override val pageClubsTab = "Клуби"
    override val pageFilterLocation = "Локація"
    override val pageUnnamedCommunity = "Без назви"
    override val pageFilterCommunity = "Спільнота"
    override val pageFilterAll = "Усі"
    override val pageFilterCalendar = "Календар"
    override val pageAddEvent = "Додати подію"
    override val pageAddClub = "Додати клуб"
    override val pageMap = "Карта"
    override val pageOwnTheArena = "ВОЛОДІЙ АРЕНОЮ"
    override val pageArenaBannerSubtitle = "Твоя арена чекає. Бронюй миттєво — грай впевнено."
    override val pageLoadingMoreEvents = "Завантажуємо ще події..."
    override val pageLoadingMoreClubs = "Завантажуємо ще клуби..."
    override val pageNoClubsYet = "Клубів поки немає"
    override val pageClubsWillAppear = "Клуби з'являться тут"
    override val pageEventsMapTitle = "Карта подій"
    override val pageClubsMapTitle = "Карта клубів"
    override val pageDeleteClub = "Видалити клуб"
    override val pageAddBanner = "Додати банер"
    override val pageRulePlaceholder = "напр. Потрібен спортивний одяг"
    override val pageAddRule = "Додати правило"
    override val pageEditServices = "Редагувати послуги"
    override val pageManageServices = "Керувати послугами"
    override val pageAmenityParking = "Парковка"
    override val pageAmenityCafe = "Кафе"
    override val pageAmenityWifi = "WiFi"
    override val pageAmenityReception = "Рецепція"
    override val pageAmenityShower = "Душ"
    override val pageAmenityFirstAid = "Аптечка"
    override val pageReviewsLabel = "Відгуки:"
    override val pageAvgRatingLabel = "Сер. рейтинг:"
    override val pageReviewsPlaceholderNote = "Відгуки з'являться тут після того, як користувачі залишать їх."
    override val pageClubComposePrompt = "Що відбувається у твоєму клубі?"
    override val pageClubNoPostsHint = "Поділись фото та короткою думкою, щоб клуб залишався активним."
    override val pageComposePostTitle = "Створити пост"
    override val pagePostContentPlaceholder = "Текст поста..."
    override fun pageAddImageSlot(slot: Int) = "Додати зображення $slot"
    override val pagePostAction = "Опублікувати"
    override val pageEditClubInfo = "Редагувати інфо клубу"
    override val pageClubNameLabel = "Назва клубу"
    override val pageAddressLabel = "Адреса"
    override val pageSearchAddressPlaceholder = "Пошук адреси"
    override val pageSaveChanges = "Зберегти зміни"

    // account
    override val accountRequiredTitle = "Потрібен акаунт"
    override val accountRequiredDescription = "Ця функція лише для зареєстрованих гравців. Увійди через Google або Apple, щоб продовжити."
    override val accountRequiredTermsPrefix = "Продовжуючи, ти погоджуєшся з нашими "
    override val accountRequiredTerms = "Умовами"
    override val accountRequiredPrivacy = "Конфіденційністю"

    // avatar
    override val avatarGenTitle = "AI-аватар"
    override val avatarGenErrorFileType = "Дозволені лише файли JPEG, PNG та WebP"
    override val avatarGenErrorFileSize = "Розмір файлу має бути до 30 МБ"
    override val avatarGenGenerating = "Генерація…"
    override val avatarGenGenerate = "Згенерувати"
    override fun avatarGenGenerateWithPrice(price: String) = "Згенерувати · $price"
    override val avatarGenGeneratedLook = "Згенерований образ"
    override val avatarGenDropPhotoHere = "Перетягни сюди своє фото"
    override val avatarGenMaxFileSize = "макс. 30 МБ"
    override val avatarGenReadyToGenerate = "Готово до генерації"
    override val avatarGenCustomPrompt = "Свій промпт"
    override val avatarGenPromptPlaceholder = "Додай деталі, щоб задати стиль ..."
    override val avatarGenInfoDefaultBehavior = "За замовчуванням ШІ виріже тебе з фото та розмістить на картці."
    override val avatarGenInfoPromptIntro = "У промпті також можна попросити:"
    override val avatarGenInfoBulletZoom = "Наблизити або віддалити фігуру"
    override val avatarGenInfoBulletObject = "Додати чи прибрати об'єкт (напр. окуляри, джерсі, м'яч, кепку)"
    override val avatarGenOptionalBadge = "(Необов'язково)"

    // card
    override val cardLifeTitle = "Оживи свою картку"
    override val cardLifeSubtitle = "Створи свою візуальну ідентичність"
    override val cardLifeMyStyles = "Мої стилі"
    override val cardLifeSelectToGenerate = "Вибери для генерації"
    override val cardLifeActiveCards = "Активні картки профілю"
    override val cardLifeDragToReorder = "Перетягуй, щоб змінити порядок"
    override val cardLifeNoTemplates = "Шаблонів карток поки немає. Придбай один у магазині карток."
    override val cardLifeCreatePhoto = "Створити фото"
    override val cardLifeDeleteCardTitle = "Видалити картку?"
    override val cardLifeDeleteCardMessage = "Картку буде видалено з твоєї галереї. Шаблон залишиться у твоїх стилях."

    // wallet
    override val walletTitle = "Мій гаманець"
    override val walletCredits = "Кредити"
    override val walletSignInToBuy = "Увійди, щоб купити кредити."
    override fun walletCreditsAdded(amount: Int) = "$amount кредитів додано до твого гаманця."
    override val walletPurchaseFailed = "Не вдалося купити. Спробуй ще раз."
    override fun walletBuyFor(price: String) = "Купити за $price"
    override val walletBackToPackages = "Назад до пакетів"
    override val walletSelectedPack = "Вибраний пакет"
    override fun walletOneTimePurchase(currency: String) = "$currency · Разова покупка"
    override val walletCurrentBalance = "Поточний баланс"
    override val walletNewBalance = "Новий баланс"
    override val walletSecuredNote = "Безпечно · Без регулярних списань"
    override val walletPaymentMethod = "Спосіб оплати"
    override val walletOrPayWithCard = "Або сплатіть карткою"
    override val walletCardNumber = "Номер картки"
    override val walletExpiryDate = "Термін дії"
    override val walletCvc = "CVC"
    override fun walletConfirmAndPay(price: String) = "Підтвердити й сплатити €$price"

    // complete
    override val completeProfileTitle = "Заповни профіль, щоб почати свайпати"
    override val completeProfileDescription = "Заповни профіль, щоб бачити гравців твого рівня зі спільними інтересами."
    override val completeProfileMaybeLater = "Можливо, пізніше"
    override val completeProfileAction = "Заповнити профіль"

    // preference
    override val preferenceDetailsTitle = "Деталі вподобань"

    // follow
    override val followListFollowers = "Підписники"
    override val followListFollowing = "Підписки"
    override val followListNoResults = "Нічого не знайдено"
    override val followListNoFollowersYet = "Підписників поки немає"
    override val followListNotFollowingAnyoneYet = "Ти поки ні на кого не підписаний"
    override val followListUnfollow = "Відписатися"
    override val followListFollow = "Підписатися"
    override val followListRemove = "Видалити"
    override val followListDeleted = "Видалено"

    // top
    override val topUpTitle = "Поповни свій гаманець"
    override fun topUpNeedMessage(required: String, action: String, balance: String) = "Потрібно $required, щоб $action, але в гаманці лише $balance."
    override val topUpChooseAmount = "Вибери суму"
    override val topUpOr = "або"
    override val topUpCustomAmount = "Своя сума"
    override val topUpEnterAmountPlaceholder = "Введи суму"
    override val topUpAction = "Поповнити"
    override val topUpFailed = "Не вдалося поповнити"

    // interactions
    override val interactionsTitle = "Взаємодії"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes нових лайків · $matches метчів"
    override val interactionsNewLikes = "Нові лайки"
    override val interactionsNoNewLikesTitle = "Нових лайків поки немає"
    override val interactionsNoNewLikesMessage = "Коли хтось свайпне тебе «Так», він з'явиться тут."
    override val interactionsMatches = "Метчі"
    override val interactionsNoMatchesTitle = "Метчів поки немає"
    override val interactionsNoMatchesMessage = "Свайпни «Так» тому, хто вже вподобав тебе, щоб отримати метч."

    // match
    override val matchItsWord = "Це"
    override val matchWord = "MATCH"
    override val matchSubtitle = "Час знайомитися та планувати гру."
    override val matchKeepSwiping = "Свайпати далі"
    override val matchGoToProfile = "До профілю"
    override val matchYouFallback = "Ти"

    // purchase
    override val purchaseCardTitle = "Придбати цю картку?"
    override val purchaseCardBuying = "Купівля…"
    override val purchaseCardBuyNow = "Купити зараз"

    // post
    override val postCommentsLike = "Лайк"
    override val postCommentsOneLike = "1 лайк"
    override fun postCommentsLikes(count: Int) = "$count лайків"
    override val postCommentsInputPlaceholder = "Напиши повідомлення…"

    // story
    override fun storySeenBy(count: Int) = "Переглянули: $count"

    // support
    override val supportTitle = "Зв'язатися з підтримкою"
    override val supportIntro = "Розкажи, що пішло не так або з чим потрібна допомога — ми відповімо тобі на email."
    override val supportEmailLabel = "Твій email"
    override val supportMessageLabel = "Повідомлення"
    override val supportMessagePlaceholder = "Опиши свою проблему…"
    override val supportErrorInvalidEmail = "Введи коректний email."
    override val supportErrorEmptyMessage = "Напиши повідомлення."
    override val supportErrorGeneric = "Щось пішло не так. Спробуй ще раз."
    override val supportSending = "Надсилання…"
    override val supportSendMessage = "Надіслати повідомлення"
    override val supportSentTitle = "Повідомлення надіслано!"
    override val supportSentMessage = "Дякуємо за звернення — скоро відповімо тобі на email."

    // person
    override val personDetailTabAbout = "Про гравця"
    override val personDetailTabPosts = "Пости"
    override val personDetailTabAchievement = "Досягнення"
    override val personDetailAchievementsComingSoon = "Досягнення скоро з'являться."
    override val personDetailFollowing = "Підписки"
    override val personDetailFollowers = "Підписники"
    override val personDetailSportLabel = "Спорт:"
    override val personDetailActivityLabel = "Активність:"
    override val personDetailLifestyleLabel = "Лайфстайл:"
    override val personDetailNoPostsTitle = "Постів поки немає"
    override val personDetailNoPostsMessage = "Цей гравець поки нічого не публікував."

    // common
    override val commonClose = "Закрити"
    override val commonDone = "Готово"
    override val commonLoading = "Завантаження…"
    override val commonBack = "Назад"
    override val commonSkip = "Пропустити"

    // profile
    override val profileCardShopLoading = "Завантаження..."
    override val profileCardShopEmpty = "Немає доступних карток"
    override val profileCardShopBuy = "Купити"
    override val profileCardShopFree = "Безкоштовно"
    override val profileFormationReservePlate = "Рез"
    override val profileFormationCoach = "Тренер"
    override val profileMediaEmpty = "Медіа поки немає"
    override val profileMediaImageAlt = "медіа"
    override val profileNewsPrompt = "Що у тебе на думці?"
    override val profileNewsLoading = "Завантаження..."
    override val profileNewsLoginRequired = "Увійди, щоб бачити свої пости"
    override val profileNewsEmpty = "Постів поки немає. Поділись чимось!"
    override val profileNewsPlaceholder = "Напиши щось..."
    override val profileNewsPosting = "Публікація..."
    override val profileNewsPost = "Опублікувати"
    override val profileRadarTitle = "Радар"
    override val profileRecentMatchesTitle = "Останні події"
    override val profileRecentMatchesEmptyTitle = "Запланованих подій поки немає"
    override val profileRecentMatchesEmptyHint = "Вибери майбутню подію та приєднуйся до гри!"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Команда A"
    override val profileRecentMatchesTeamB = "Команда B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count осіб"
    override val profileRecentMatchesWin = "Перемога"
    override val profileRecentMatchesLoss = "Поразка"
    override val profileRecentMatchesDraw = "Нічия"
    override val profileRecentMatchesSportFallback = "Спорт"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "Формат $format X $format"
    override fun profileRecentMatchesMembers(count: Int) = "$count учасників"
    override val profileShortcutStatistic = "Статистика"
    override val profileShortcutMedia = "Медіа"
    override val profileStatsChartsGoals = "Голи"
    override val profileStatsChartsAssists = "Асисти"
    override val profileStatsChartsPerYear = "за рік"
    override val profileStatsChartsPerWeek = "за тиждень"
    override val profileStatsChartsPerMonth = "за місяць"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "Немає даних"
    override val profileTeamEmptyOwnTitle = "У тебе поки немає команди"
    override val profileTeamEmptyOtherTitle = "Немає команди"
    override val profileTeamEmptyCreateTeam = "Створити команду"
    override val profileTrackerTitle = "Трекер"
    override val profileTrackerWorldMap = "Карта світу"
    override val profileTeamMatchesEmpty = "Матчів поки немає"
    override val profileTeamMatchesUpcomingTitle = "Майбутні матчі"
    override val profileTeamMatchesUpcomingEmpty = "Немає майбутніх матчів"
    override val profileTeamMatchesVenueAlt = "Місце проведення"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count команд"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total учасників"
    override fun profileTeamMatchesFormat(format: Int) = "Формат ${format}x${format}"
    override val profileTeamOverviewTitle = "Огляд команди"
    override val profileTeamOverviewClubTitle = "Футбольний клуб"
    override val profileTeamOverviewRating = "Рейтинг"
    override val profileTeamOverviewTeamRating = "Рейтинг команди"
    override val profileTeamOverviewStatistics = "Статистика"
    override val profileTeamOverviewWins = "Перемоги"
    override val profileTeamOverviewDraws = "Нічиї"
    override val profileTeamOverviewLosses = "Поразки"
    override val profileSidebarTitle = "Огляд"
    override val profileSidebarFollowing = "Підписки"
    override val profileSidebarFollowers = "Підписники"
    override val profileSidebarAchievement = "Досягнення"
    override val profileSidebarAboutYouEmpty = "Додай кілька слів про себе, щоб представити свій профіль"
    override val profileSidebarFocusActivities = "Фокус і активності"
    override val profileSidebarSportLabel = "Спорт"
    override val profileSidebarActivityLabel = "Активність"
    override val profileSidebarLifestyleLabel = "Лайфстайл"
    override val profileSidebarChat = "Чат"
    override val profileSidebarFollow = "Підписатися"
    override val profileSidebarUnfollow = "Відписатися"
    override val profileSidebarNoInterests = "Інтересів поки немає"
    override val profileSidebarNoInterestsBody = "Покажи іншим свої хобі та види спорту."
    override val profileHubTitle = "Хаб гравця"
    override val profileHubYourStories = "Твої сторіз"
    override val profileHubStories = "Сторіз"
    override val profileHubCardShopUnavailable = "Магазин карток недоступний"
    override val profileHubCardShopTitle = "Магазин карток"
    override val profileHubCardShopSubtitle = "Купуй нові картки. Визнач свій стиль."
    override val profileHubActiveBought = "Активні та куплені"
    override fun profileHubOwnedCount(count: Int) = "У власності: $count"
    override val profileHubNoCardsYet = "Карток поки немає"
    override val profileHubAvailableForPurchase = "Доступні для покупки"
    override val profileHubNewDesignsRegularly = "Нові дизайни регулярно"
    override val profileHubAllCardsOwned = "Усі картки вже твої"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat за $period"
    override val profileHubNoChartsTitle = "Немає доступних графіків"
    override val profileHubNoChartsBody = "Вибери конкретний вид спорту в шапці, щоб бачити голи, асисти, ігри та решту статистики."
    override val profileHubContentTitle = "Контент"
    override val profileHubLoading = "Завантаження..."
    override val profileHubAddStory = "Додати сторіз"
    override val profileHubAddPost = "Додати пост"
    override val profileHubUserFallback = "користувач"
    override val profileHubNoPostsYet = "Постів поки немає"
    override val profileHubShareFirstMoment = "Поділись своїм першим моментом"
    override val profileHubPlayerNotPosted = "Цей гравець поки нічого не публікував."
    override val profileOverviewTitle = "Огляд гравця"
    override val profileOverviewPlayerIdentify = "Ідентичність гравця"
    override val profileOverviewChat = "Чат"
    override val profileOverviewAiAvatar = "AI-аватар"
    override val profileOverviewGoals = "Голи"
    override val profileOverviewGoalsUnit = "голів"
    override val profileOverviewWins = "Перемоги"
    override val profileOverviewWinsUnit = "перемог"
    override val profileOverviewDraws = "Нічиї"
    override val profileOverviewDrawsUnit = "нічиїх"
    override val profileOverviewLosses = "Поразки"
    override val profileOverviewLossesUnit = "поразок"
    override val profileOverviewAchievements = "Досягнення"
    override val profileOverviewNotFollowingAnyone = "Поки ні на кого не підписаний"
    override val profileOverviewComingSoon = "Скоро"
    override val profileAwardsEmpty = "Поки що немає нагород"
    override val awardWelcomeTitle = "Вітальна нагорода"
    override val awardTermScorerFootball = "Найкращий бомбардир"
    override val awardTermAssistFootball = "Найкращий асистент"
    override val awardTermScorerBasketball = "Найрезультативніший"
    override val awardTermAssistBasketball = "Найкращий асистент"
    override val awardTermScorerTennis = "Найбільше вінерів"
    override val awardTermAssistTennis = "Найбільше ейсів"
    override val awardTermScorerVolleyball = "Найкращий атакувальник"
    override val awardTermAssistVolleyball = "Найкращий асистент"
    override val awardTermScorerPadel = "Найбільше вінерів"
    override val awardTermAssistPadel = "Найбільше смешів"
    override val awardTermScorerGeneric = "Найкращий бомбардир"
    override val awardTermAssistGeneric = "Найкращий асистент"
    override val awardRank1 = "1-ше місце"
    override val awardRank2 = "2-ге місце"
    override val awardRank3 = "3-тє місце"
    override val profileOverviewAddPost = "Додати пост"
    override val profileOverviewWritePlaceholder = "Напиши щось..."
    override val profileOverviewPost = "Опублікувати"
    override val profileOverviewLoading = "Завантаження..."
    override val profileOverviewLoginToSeePosts = "Увійди, щоб бачити пости"
    override val profileOverviewNoPostsYet = "Постів поки немає"
    override val profileWizardLetsGo = "Погнали!"
    override val profileWizardStepPersonalInfoTitle = "Особиста інформація"
    override val profileWizardStepPersonalInfoDescription = "Розкажи про себе, щоб почати."
    override val profileWizardStepFocusTitle = "Фокус і активності"
    override val profileWizardStepFocusDescription = "Вибери свої види спорту та лайфстайл"
    override val profileWizardStepCardTitle = "Оживи свою картку"
    override val profileWizardStepCardDescription = "Створи свою візуальну ідентичність"
    override fun profileWizardSelectedCount(count: Int) = "Вибрано: $count"
    override val profileWizardPublicInfo = "Публічна інформація"
    override val profileWizardMyStyles = "Мої стилі"
    override val profileWizardSelectToGenerate = "Вибери для генерації"
    override val profileWizardNoTemplates = "Шаблони карток поки недоступні."
    override val profileWizardActiveCards = "Активні картки профілю"
    override val profileWizardDragToReorder = "Перетягуй, щоб змінити порядок"
    override fun profileWizardCardCount(count: Int) = "$count " + when {
        count % 10 == 1 && count % 100 != 11 -> "картка"
        count % 10 in 2..4 && count % 100 !in 12..14 -> "картки"
        else -> "карток"
    }
    override val profileWizardCreatePhoto = "Створити фото"
    override val profileFocusEditTitle = "Фокус і активності"
    override val profileFocusEditDescription = "Вибери свої види спорту та лайфстайл, щоб сформувати свою ідентичність."
    override val profileFocusEditSelectedLabel = "вибрано"
    override val profileFocusEditClearAll = "Очистити все"
    override val profileFocusEditSearchPlaceholder = "Пошук атрибутів…"
    override val profileFocusEditSportLabel = "Спорт"
    override val profileFocusEditActivityLabel = "Активність"
    override val profileFocusEditLifestyleLabel = "Лайфстайл"
    override val profileFocusEditNoMatches = "Збігів немає"
    override val profileFocusEditPreferenceDetails = "Деталі вподобань"
    override val profileFocusEditPreferenceHint = "Необов'язково, але допомагає швидше знаходити однодумців."
    override val profileFocusEditNoteLabel = "Нотатка"
    override val profileFocusEditNotePlaceholder = "Що ти шукаєш?"
    override val profileFocusEditAddDetails = "Додати деталі"
    override val profilePersonalEditTitle = "Особиста інформація"
    override val profilePersonalEditDescription = "Розкажи про себе, щоб почати."
    override val profilePersonalEditFirstNameLabel = "Ім'я"
    override val profilePersonalEditLastNameLabel = "Прізвище"
    override val profilePersonalEditAboutMeLabel = "Про мене"
    override val profilePersonalEditBioPlaceholder = "Розкажи іншим гравцям трохи про себе…"
    override val profilePersonalEditDobLabel = "Дата народження"
    override val profilePersonalEditCityLabel = "Місто"
    override val profilePersonalEditCitySearchPlaceholder = "Пошук міста…"
    override val profilePersonalEditLanguagesLabel = "Мови"
    override val profilePersonalEditTypeLanguagePlaceholder = "Введи мову…"
    override val profilePersonalEditAddLanguagePlaceholder = "Додати мову…"
    override val profileEditSheetPublicInfo = "Публічна інформація"
    override val profileEditShellPublicInfo = "Публічна інформація"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Додати всі фото ($count)"
    override val profileCreatePostUploadFailed = "Не вдалося завантажити"
    override val profileCreatePostCreateFailed = "Не вдалося створити пост"
    override val profileCreatePostTitle = "Створити пост"
    override val profileCreatePostChooseLayout = "Вибери макет"
    override val profileCreatePostFileTooLarge = "Файл завеликий (макс. 50 МБ)"
    override val profileCreatePostCreating = "Створення..."
    override val profileCreatePostAddPhoto = "Додати фото"
    override val profileCreatePostContentLabel = "Текст поста"
    override val profileCreatePostContentPlaceholder = "Напиши щось про цей пост..."
    override val profileCreatePostCityLabel = "Місто"
    override val profileCreatePostCityPlaceholder = "Введи назву міста..."
    override val profileCreateStoryPickPhotoFirst = "Спочатку вибери фото"
    override val profileCreateStoryUploadFailed = "Не вдалося завантажити"
    override val profileCreateStoryCreateFailed = "Не вдалося створити сторіз"
    override val profileCreateStoryTitle = "Створити сторіз"
    override val profileCreateStorySubtitle = "Створюй і ділись своїми моментами"
    override val profileCreateStoryFileTooLarge = "Файл завеликий (макс. 30 МБ)"
    override val profileCreateStoryCreating = "Створення..."
    override val profileCreateStoryDropHere = "Перетягни сюди свій контент"
    override val profileCreateStoryMaxSize = " макс. 30 МБ"
    override val profileFollowListFollowers = "Підписники"
    override val profileFollowListFollowing = "Підписки"
    override val profileFollowListNoResults = "Нічого не знайдено"
    override val profileFollowListUnfollow = "Відписатися"
    override val profileFollowListFollow = "Підписатися"
    override val profileFollowListRemoved = "Видалено"
    override val profileFollowListRemove = "Видалити"
    override val profileFollowListNotFollowingTitle = "Ти поки ні на кого не підписаний"
    override val profileFollowListNotFollowingBody = "Підписуйся на гравців, щоб бачити їхні свіжі пости, хайлайти та сторіз у своїй стрічці."
    override val profileFollowListDiscoverPlayers = "Знайти гравців"
    override val profileFollowListNoFollowersTitle = "Підписників поки немає"
    override val profileFollowListNoFollowersBody = "Ділись постами про матчі та сторіз, щоб тебе помітила спільнота."
    override val profileDialogPreferenceDetails = "Деталі вподобань"
    override val profileStoryViewersTitle = "Хто бачив цю сторіз?"
    override val profileStoryViewersNoViews = "Переглядів поки немає"
    override val profileContentMobileOverview = "Огляд"
    override val profileContentMobileFollowing = "Підписки"
    override val profileContentMobileFollowers = "Підписники"
    override val profileContentMobileAwardsComingSoon = "Нагороди скоро з'являться"
    override val profileContentMobileRecentEvents = "Останні події"
    override val profileContentMobileNoEvents = "Запланованих подій поки немає"
    override val profileContentMobileNoEventsBody = "Вибери майбутню подію та приєднуйся до гри!"
    override val profileContentMobileResultWin = "Перемога"
    override val profileContentMobileResultDraw = "Нічия"
    override val profileContentMobileResultLoss = "Поразка"
    override val profileContentMobileSportFallback = "Спорт"
    override fun profileContentMobileFormat(format: Int) = "Формат $format X $format"
    override fun profileContentMobileMembers(count: Int) = "$count учасників"
    override val profileContentMobilePlayerHub = "Хаб гравця"
    override val profileContentMobileNoPostsTitle = "Постів поки немає"
    override val profileContentMobileNoPostsOwnBody = "Ділись фото з матчів і хайлайтами, щоб наповнити свій профіль."
    override val profileContentMobileNoPostsOtherBody = "Цей гравець поки нічого не публікував."
    override val profileContentMobileCardsUnavailable = "Картки недоступні"
    override val profileContentMobileCardsLoadFailed = "Не вдалося завантажити картки"
    override val profileContentMobileNoCardsAvailable = "Немає доступних карток"
    override val profileContentMobileActiveBought = "Активні та куплені"
    override fun profileContentMobileOwnedCount(count: Int) = "У власності: $count"
    override val profileContentMobileAvailableForPurchase = "Доступні для покупки"
    override val profileContentMobileNewDesigns = "Нові дизайни регулярно"
    override val profileContentMobileNoCardsYet = "Карток поки немає"
    override val profileContentMobileCardsTitle = "Картки"
    override val profileContentMobileAddPost = "Додати пост"
    override val profileContentMobileUserFallback = "користувач"
    override val profileUserSheetError = "Щось пішло не так"
    override val profileUserSheetThisUser = "цього користувача"
    override fun profileUserSheetUnfollowTitle(name: String) = "Відписатися від $name?"
    override val profileUserSheetRefollowHint = "Ти можеш підписатися знову будь-коли."
    override val profileUserSheetUnfollow = "Відписатися"

    // header
    override val headerNavHome = "Головна"
    override val headerNavAbout = "Про нас"
    override val headerNavServices = "Послуги"
    override val headerNavProjects = "Проєкти"
    override val headerNavContacts = "Контакти"
    override val headerSportLabel = "Спорт:"
    override val headerUserFallbackName = "Користувач"
    override val headerNoActiveEvents = "Немає активних подій чи бронювань"
    override val headerNoNotifications = "Немає сповіщень"
    override val headerYourActiveEvents = "Твої активні події "
    override val headerNotificationsTitle = "Сповіщення "
    override val headerMarkAllRead = "Позначити все прочитаним"
    override val headerLoadMore = "Завантажити ще"
    override val headerPendingApproval = "Очікує підтвердження"
    override val headerEventStatusNew = "Нова"
    override val headerEventStatusInProgress = "Триває"
    override val headerEventStatusCompleted = "Завершено"
    override val headerEventStatusCancelled = "Скасовано"
    override val headerBookingFallback = "Бронювання"
    override val headerActionView = "Переглянути"
    override val headerActionReply = "Відповісти"
    override val headerActionUnfollow = "Відписатися"
    override val headerActionFollowBack = "Підписатися у відповідь"
    override val headerActionAccept = "Прийняти"
    override val headerActionDecline = "Відхилити"
    override val headerConfirmTitle = "Ти впевнений?"
    override val headerSignOutConfirmMessage = "Ти вийдеш з Arena на цьому пристрої. Твої дані в безпеці."
    override val headerSignOutConfirmLabel = "Вийти"
    override val headerDeleteConfirmMessage = "Видалення профілю незворотне. Усі кредити, моменти та статистика будуть стерті."
    override val headerDeleteConfirmLabel = "Підтвердити видалення"
    override val headerDeleteProfileFailed = "Не вдалося видалити профіль. Спробуй ще раз."
    override val headerUploading = "Завантаження..."
    override val headerVisualStyle = "Візуальний стиль"
    override val headerSyncWithSportType = "Синхронізувати з видом спорту"
    override val headerMyWallet = "Мій гаманець"
    override val headerSignOut = "Вийти"
    override val headerSigningOut = "Вихід..."
    override val headerDeleteProfile = "Видалити профіль"
    override val headerRequestNoLongerAvailable = "Цей запит більше недоступний."
    override val headerRequestProcessFailed = "Не вдалося обробити запит. Спробуй ще раз."
    override val headerSelectClub = "Вибрати клуб"
    override val headerAddClub = "Додати клуб"
    override val headerSwitchToPlayer = "Перейти в режим гравця"
    override val headerLogout = "Вийти"
    override val headerLoggingOut = "Вихід..."
    override val headerSigningIn = "Вхід..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "об'єднує"
    override val homeHeroAthletes = "спортсменів"
    override val homeHeroAndTeams = "і команди"
    override val homeHeroWorldwideFor = "по всьому світу для"
    override val homeSectionCreateEventsTitle = "Створюй події"
    override val homeSectionCreateEventsHighlight = "події"
    override val homeSectionCreateEventsSubtitle1 = "Вибери вид спорту, налаштуй розклад"
    override val homeSectionCreateEventsSubtitle2 = "і додай місце гри."
    override val homeSectionTeammatesTitle = "Знаходь ідеальних тіммейтів"
    override val homeSectionTeammatesHighlight = "тіммейтів"
    override val homeSectionMomentsTitle = "Ділись моментами, спілкуйся з друзями"
    override val homeSectionMomentsHighlight = "друзями"
    override val homeSectionStatsTitle = "Відстежуй статистику, прогрес розвитку та кастомізуй картку"
    override val homeSectionStatsHighlight = "прогрес"
    override val homeAltEventsScreen = "Екран подій"
    override val homeAltCreateEventScreen = "Екран створення події"
    override val homeAltCreateEventModal = "Модальне вікно створення події"
    override val homeAltEventDetailScreen = "Екран деталей події"
    override val homeAltDiscoverPeople = "Пошук людей"
    override val homeAltPlayerDiscoveryCard = "Картка пошуку гравця"
    override val homeAltMatchedInterests = "Спільні інтереси"
    override val homeAltMatchedInterestsModal = "Модальне вікно спільних інтересів"
    override val homeAltItsAMatch = "Це метч"
    override val homeAltFeedScreen = "Екран стрічки"
    override val homeAltFeedPost = "Пост у стрічці"
    override val homeAltGameMomentsPost = "Пост з ігровими моментами"
    override val homeAltChatScreen = "Екран чату"
    override val homeAltProfileOverview = "Огляд профілю"
    override val homeAltProfileDashboard = "Дашборд профілю"
    override val homeAltPlayerStatsRadar = "Радар статистики гравця"
    override val homeAltPlayerStatsCard = "Картка статистики гравця"
    override val homeAltRatePerformance = "Оцінка гри"
    override val homeAltRatePerformanceModal = "Модальне вікно оцінки гри"
    override val homeItsYourMatch = "Це твій метч!"
    override val homeLabelGameMoments = "Ігрові моменти"
    override val homeLabelPlayerStats = "Статистика гравця"
    override val homeLabelRatePerformance = "Оціни гру"
    override val homeFooterTagline = "Твоя світова спортивна спільнота"
    override val homeFooterBlurb = "Знаходь людей поруч для гри у футбол, теніс, баскетбол, падел чи волейбол — приєднуйся до ігор і локальних спортивних подій або створюй власні на Arena."
    override val homeFooterAbout = "Про нас"
    override val homeFooterTerms = "Умови користування"
    override val homeFooterPrivacy = "Політика конфіденційності"
    override val homeFooterPricing = "Ціни"
    override val homeFooterRefund = "Політика повернення"
    override val homeFooterSupports = "Підтримка"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "ЗАВАНТАЖУЙ В"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "ДОСТУПНО В"
    override val homeStoreGoogleName = "Google Play"

    // dashboard
    override val dashboardTabAnalytics = "Аналітика"
    override val dashboardTabSchedule = "Розклад"
    override val dashboardRatingTitle = "Рейтинг"
    override val dashboardReviews = "відгуків"
    override val dashboardAvgDuration = "Сер. тривалість"
    override val dashboardTotalRevenue = "Загальний дохід"
    override val dashboardTotalBookings = "Всього бронювань"
    override val dashboardArenaSchedule = "Розклад арени"
    override val dashboardThisWeek = "Цього тижня"
    override val dashboardAddEvent = "Додати подію"
    override val dashboardTimeHeader = "Час"
    override val dashboardCustomerFallback = "Клієнт"
    override val dashboardRevenueTitle = "Дохід"
    override val dashboardBookingsTitle = "Бронювання"
    override val dashboardBookingStatusTitle = "Статус бронювань"
    override val dashboardBookingHeatmapTitle = "Теплова карта бронювань"
    override val dashboardDonutTotal = "Всього"
    override val dashboardBookingsTooltipPrefix = "Бронювання "
    override val dashboardStatusConfirmed = "Підтверджено"
    override val dashboardStatusCompleted = "Завершено"
    override val dashboardStatusPending = "Очікує"
    override val dashboardStatusUnpaid = "Не оплачено"
    override val dashboardStatusDeclined = "Відхилено"
    override val dashboardNoData = "Немає даних"
    override val dashboardDayMon = "Пн"
    override val dashboardDayTue = "Вт"
    override val dashboardDayWed = "Ср"
    override val dashboardDayThu = "Чт"
    override val dashboardDayFri = "Пт"
    override val dashboardDaySat = "Сб"
    override val dashboardDaySun = "Нд"
    override fun dashboardHourLabel(hour: Int) = "${hour} год"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count бронювань"

    // arena
    override val arenaActionViewResults = "Переглянути результати"
    override val arenaActionWatchLive = "Дивитися наживо"
    override val arenaActionJoinNow = "Приєднатися зараз"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "Нова"
    override val arenaStatusCompleted = "Завершено"
    override val arenaStatusCanceled = "Скасовано"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total учасників"
    override fun arenaMembersCount(count: Int) = "$count учасників"
    override fun arenaTeamsCount(count: Int) = "$count команд"
    override fun arenaFormat(format: String) = "Формат $format"
    override fun arenaFinalScore(score: String) = "Фінальний рахунок $score"
    override fun arenaDuration(duration: String) = "Тривалість $duration"
    override val arenaLoadingClubs = "Завантаження клубів..."
    override val arenaLoadingMoreEvents = "Завантажуємо ще події..."
    override val arenaLoadingMoreClubs = "Завантажуємо ще клуби..."
    override val arenaLocationLabel = "Локація: "
    override val arenaAllCities = "Усі міста"
    override val arenaCommunityAll = "Усі"
    override val arenaCommunityUnnamed = "Без назви"
    override val arenaTabClubs = "Клуби"
    override val arenaTabEvents = "Події"
    override val arenaEmptyTitle = "Запланованих подій поки немає"
    override val arenaEmptySubtitle = "Створи подію з чатом матчу та відстеженням у реальному часі."
    override val arenaAddEvent = "Додати подію"
    override val arenaNoClubsTitle = "Клубів поки немає"
    override val arenaNoClubsSubtitle = "Клуби з'являться тут"

    // people
    override val peopleErrorLoad = "Не вдалося завантажити людей"
    override val peopleCaughtUpTitle = "Усе переглянуто"
    override val peopleCaughtUpSubtitle = "Повертайся пізніше — буде більше гравців."
    override val peopleRefresh = "Оновити"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Твоя стрічка порожня"
    override val feedEmptySubtitle = "Підписуйся на гравців, щоб бачити тут їхні пости й сторіз."
    override val feedNoCommentsTitle = "Коментарів поки немає"
    override val feedNoCommentsSubtitle = "Прокоментуй першим."
    override val feedMessagePlaceholder = "Напиши повідомлення..."
    override val feedLikeZero = "Лайк"
    override val feedLikeOne = "1 лайк"
    override fun feedLikeMany(count: Int) = "$count лайків"

    // auth
    override val authWelcomeTitle = "Ласкаво просимо на Arena!"
    override val authWelcomeSubtitle = "Увійди через Google або Apple, щоб створити профіль, відкрити цю сторінку та почати свою спортивну подорож з нами."
    override val authAgreePrefix = "Продовжуючи, ти погоджуєшся з нашими"
    override val authTerms = "Умовами"
    override val authPrivacy = "Конфіденційністю"

    // layout
    override val layoutComingSoon = "Скоро"
}
